import { Collection, CollectionPrinter, Div } from "@tblabs/truffle";
import { FaqField } from "../../../Models/Description/Faq/FaqField";
import { FaqEntryEditor } from "./FaqEntryEditor";
import { Field } from "../../../Models/Description/Field";
import { Faq } from "../../../Models/Description/Faq/Faq";
import { FieldEditor } from "../../Utils/FieldEditor";
import { AddFieldBox } from "../../Admin/AddFieldBox";
import { Tab } from "../../../Models/Product/Tab";


export class FaqsEditor extends FieldEditor
{
    constructor(field: FaqField, fields: Collection<Field>, tabs: Collection<Tab>)
    {
        super("FAQ", field, fields, tabs, [
            new CollectionPrinter(field.Questions, x => new FaqEntryEditor(x, field.Questions)),
            new AddFieldBox({
                "➕ Q&A": () => field.Questions.Add(new Faq({ Question: "", Answer: "" })),
            }),
        ]);
    }
}

export class FaqListEditor extends Div
{
    constructor(fields: Collection<Faq>)
    {
        super();
        
        this.Append(
            new CollectionPrinter(fields, x => new FaqEntryEditor(x, fields)),
            new AddFieldBox({
                "➕ Q&A": () => fields.Add(new Faq({ Question: "", Answer: "" })),
            }),
        );
    }
}
